"use client";

import { IoMdArrowRoundBack } from "react-icons/io";
import { FaCheckCircle, FaCircle } from "react-icons/fa"; // Importar iconos adicionales
import { useRouter } from "next/navigation";

const ProgressCircle = ({
  isSyncing,
  onBack,
  title,
  description,
  currentStep = 0,
  totalSteps = 0,
  needBack = true,
}) => {
  const router = useRouter();

  const handleBack = () => {
    onBack();
    router.push("/");
  };

  return (
    <>
      {isSyncing && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-lg p-4 flex flex-col items-center justify-center gap-4">
            <p className="text-lg font-bold">{title}</p>
            <p className="text-sm font-semibold">{description}</p>
            <div className="flex items-center gap-2">
              {Array.from({ length: totalSteps }).map((_, index) => (
                <div key={index} className="flex items-center">
                  {index + 1 < currentStep ? (
                    <FaCheckCircle className="text-green-500" />
                  ) : index + 1 === currentStep ? (
                    <FaCircle className="text-blue-500" />
                  ) : (
                    <FaCircle className="text-gray-300" />
                  )}
                  {index + 1 < totalSteps && (
                    <div className="w-4 h-1 bg-gray-300 mx-1"></div>
                  )}
                </div>
              ))}
            </div>

            {needBack && (
              <div
                className="flex items-center gap-2 text-blue-500 hover:text-blue-600 cursor-pointer font-semibold"
                onClick={handleBack}
              >
                <IoMdArrowRoundBack />
                <span className="text-sm ">Seguir navegando en REDI</span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProgressCircle;
